import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SchoolsRoutingModules } from './schools-routing.modules'
import { CollectionsResolver } from '../collections/collections.resolver'
import { SharedModule } from '../shared/shared.module'
import { CollectionsService } from '../libs/collections/services/collections.service'
import { EntityHubDataService } from '../entity-hub/entity-hub-data.service'
import { CollectionFacade } from '../collections/collection.facade'

@NgModule({
  imports: [SharedModule, CommonModule, RouterModule, SchoolsRoutingModules],
  providers: [CollectionsResolver, CollectionsService, EntityHubDataService, CollectionFacade]
})
export class SchoolsModule {}
